import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Checkbox, Grid, Select} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import CommercialTable from '../../../../common/components/commercialTable/commercialTable';
import {DefaultColumnFilter} from '../../../../manageOrders/components/internalCommons/TableFilters';
import WtsParamsModal from './paramsModal';
import WtsParamsTechDetailsModal from './paramStatusTechDetailsModal';

const {
  getWtsParams,
  deleteWtsParam,
  updateWtsParam,
} = Actions;

function WtsParams({activeTab}) {
  const wtsParams = useSelector((state) => state.wtsParams.params);
  const areaSelected = useSelector((state) => state.wtsAreas.areaSelected);
  const dispatch = useDispatch();

  useEffect(() => {
    if (areaSelected && activeTab === 7) {
      dispatch(getWtsParams({'area': areaSelected.id}));
    }
  }, [areaSelected, activeTab]);

  const toggleParamStatus = (e, checkedValue, item) => {
    e.preventDefault();
    if (checkedValue) {
      dispatch(updateWtsParam(item.param_id, {...item, 'estado': 'ACTIVO'}, areaSelected.id));
    } else {
      dispatch(deleteWtsParam(item.param_id, areaSelected.id));
    }
  };

  const SelectColumnFilter = ({
    'column': {filterValue, setFilter},
  }) => {
    const options = [
      {'key': 'all', 'value': '', 'text': 'TODOS'},
      {'key': 'active', 'value': 'ACTIVO', 'text': 'ACTIVO'},
      {'key': 'inactive', 'value': 'INACTIVO', 'text': 'INACTIVO'},
    ];

    return (
      <Select
        compact
        placeholder="TODOS"
        value={filterValue || ''}
        options={options}
        style={{'minWidth': '120px', 'width': '100%'}}
        onChange={(e, {value}) => {
          setFilter(value || '');
          if (!value) {
            dispatch(getWtsParams({'area': areaSelected.id}));
          }
        }}
      />
    );
  };

  const columns = [
    {
      'Header': () => <span className="header-title">CÓDIGO LLAVE</span>,
      'accessor': 'codigo_llave',
      'Filter': DefaultColumnFilter,
    },
    {
      'Header': () => <span className="header-title">DESCRIPCIÓN</span>,
      'accessor': 'descripcion',
      'Filter': DefaultColumnFilter,
    },
    {
      'Header': () => <span className="header-title">VALOR NUMÉRICO</span>,
      'accessor': 'valor_numerico',
      'Filter': DefaultColumnFilter,
    },
    {
      'Header': () => <span className="header-title">VALOR TEXTO</span>,
      'accessor': 'valor_texto',
      'Filter': DefaultColumnFilter,
    },
    {
      'Header': () => <span className="header-title">VALOR FECHA</span>,
      'accessor': 'valor_fecha',
      'Filter': DefaultColumnFilter,
    },
    {
      'Header': () => <span className="header-title">ESTADO</span>,
      'accessor': 'estado',
      'Filter': SelectColumnFilter,
      'filter': (rows, id, filterValue) => {
        if (filterValue === '' || !filterValue) {
          return rows;
        }
        return rows.filter((row) => row.values[id] === filterValue);
      },
      'Cell': (item) => (
        <Checkbox
          toggle
          checked={item.value === 'ACTIVO'}
          className='green'
          onChange={(e, input) => toggleParamStatus(e, input.checked, item.row.original)}
        />
      ),
    },
    {
      'Header': () => <span className="header-title">ACCIONES</span>,
      'id': 'params_actions',
      'width': 1,
      'Cell': (item) => (
        <div className='flex center end'>
          <WtsParamsModal mode='edit' paramToEdit={item.row.original} />
        </div>
      ),
    },
  ];

  return (
    <Grid padded>
      <Grid.Row style={{'padding': 0}}>
        <Grid.Column textAlign='left' width={14}>
          <WtsParamsModal mode='new' />
        </Grid.Column>
        <Grid.Column width={2} textAlign='right'>
          <WtsParamsTechDetailsModal />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={16}>
          <CommercialTable
            columns={columns}
            data={wtsParams}
            defaultColumnFilter={DefaultColumnFilter}
            defaultPagination={10}
            initialState={{
              'filters': [
                {
                  'id': 'estado',
                  'value': '',
                },
              ],
            }}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
}

export default WtsParams;
